
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Video from 'plaid-threads/Icons/Video';
export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Errors specific to the Bank Transfers product',
  title: 'Bank Transfers',
  noIndex: true
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Callout = makeShortcode("Callout");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header title='Bank Transfers errors' subtitle={metadata.description} mdxType="Header" />
    <Callout warning mdxType="Callout">
      <p>{`Bank Transfers (except for webhook micro-deposit notifications) is a legacy product that has been succeeded by the `}<a parentName="p" {...{
          "href": "/docs/transfer"
        }}>{`Transfer`}</a>{` product. This documentation is retained for customers already using the Bank Transfers product; all other customers should use `}<a parentName="p" {...{
          "href": "/docs/transfer"
        }}>{`Transfer`}</a>{` instead.`}</p>
    </Callout>
    <h4 {...{
      "id": "bank_transfer_limit_exceeded"
    }}><strong parentName="h4">{`BANK_TRANSFER_LIMIT_EXCEEDED`}</strong></h4>
    <ErrorReference type='BANK_TRANSFER_ERROR' error='BANK_TRANSFER_LIMIT_EXCEEDED' subtitle="The attempted bank transfer exceeded the account's daily bank transfer or single bank transfer limits." server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The attempted bank transfer exceeded the account's daily bank transfer or single bank transfer limits. The error message will indicate which transfer limit was exceeded.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`If the limit exceeded was a daily limit, and your use case allows it, retry the transfer again later.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "bank_transfer_missing_origination_account"
    }}><strong parentName="h4">{`BANK_TRANSFER_MISSING_ORIGINATION_ACCOUNT`}</strong></h4>
    <ErrorReference type='BANK_TRANSFER_ERROR' error='BANK_TRANSFER_MISSING_ORIGINATION_ACCOUNT' subtitle="There are multiple origination accounts available for the transfer, but which account to use was not specified." server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-1"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`There is more than one origination account associated with the client id, but no account was specified in the request.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-1"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Make sure to specify an `}<inlineCode parentName="p">{`origination_account_id`}</inlineCode>{` when calling `}<inlineCode parentName="p">{`/bank_transfer/create`}</inlineCode>{` or `}<inlineCode parentName="p">{`/bank_transfer/balance/get`}</inlineCode>{`.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "bank_transfer_invalid_origination_account"
    }}><strong parentName="h4">{`BANK_TRANSFER_INVALID_ORIGINATION_ACCOUNT`}</strong></h4>
    <ErrorReference type='BANK_TRANSFER_ERROR' error='BANK_TRANSFER_INVALID_ORIGINATION_ACCOUNT' subtitle="The origination account specified for the bank transfer was invalid." server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-2"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The `}<inlineCode parentName="li">{`origination_account_id`}</inlineCode>{` specified when calling `}<inlineCode parentName="li">{`/bank_transfer/create`}</inlineCode>{` was invalid.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-2"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Ensure that the `}<inlineCode parentName="p">{`origination_account_id`}</inlineCode>{` you are using corresponds to a valid origination account owned by you. You can obtain your `}<inlineCode parentName="p">{`origination_account_id`}</inlineCode>{` from your Plaid account manager. Also ensure that the casing matches, as all Plaid identifiers are case-sensitive.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "bank_transfer_account_blocked"
    }}><strong parentName="h4">{`BANK_TRANSFER_ACCOUNT_BLOCKED`}</strong></h4>
    <ErrorReference type='BANK_TRANSFER_ERROR' error='BANK_TRANSFER_ACCOUNT_BLOCKED' subtitle="The bank transfer could not be completed because a previous transfer involving the same end-user account resulted in an error." server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-3"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The end user has previously marked a bank transfer transaction originated by you as an unauthorized transfer (applies to Plaid developers using FBO accounts only).`}</li>
        <li parentName="ul">{`Plaid has flagged the end-user's account as not valid for use with Bank Transfers.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-3"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Ask the end user to link a different account with Plaid and re-attempt the transfer with the new account.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`(FBO accounts only) Use `}<inlineCode parentName="p">{`/bank_transfer/event/list`}</inlineCode>{` to find previous events for this `}<inlineCode parentName="p">{`account_id`}</inlineCode>{` and determine if any were rejected with an ACH return code of R10 (customer advises not authorized) or R29 (corporate customer advises not authorized). If you find any such transactions, reach out to the end user to understand why the transfer was rejected, in order to prevent re-occurrence of this error with the newly linked account.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "bank_transfer_insufficient_funds"
    }}><strong parentName="h4">{`BANK_TRANSFER_INSUFFICIENT_FUNDS`}</strong></h4>
    <ErrorReference type='BANK_TRANSFER_ERROR' error='BANK_TRANSFER_INSUFFICIENT_FUNDS' subtitle="There was not enough money in the origination account (FBO accounts only) to execute the transfer." server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-4"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`An attempt was made to transfer money out of the origination account that would leave the balance of the origination account below the required minimum reserve balance.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-4"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`If you have a large number of outstanding pending debit transactions, wait for the batch to post to your account, which will increase your available balance.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`Reduce the amount of the transfer and try again.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "bank_transfer_not_cancellable"
    }}><strong parentName="h4">{`BANK_TRANSFER_NOT_CANCELLABLE`}</strong></h4>
    <ErrorReference type='BANK_TRANSFER_ERROR' error='BANK_TRANSFER_NOT_CANCELLABLE' subtitle="The bank transfer could not be canceled." server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-5"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`An attempt was made to cancel a bank transfer that has already been sent to the network for execution. Bank transfers cannot be canceled at this stage.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-5"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Use an endpoint such as `}<inlineCode parentName="p">{`/bank_transfer/get`}</inlineCode>{` to check the value of the `}<inlineCode parentName="p">{`cancellable`}</inlineCode>{` property before canceling a transfer.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`If applicable, contact the counterparty to the transfer and ask them to return the funds after the transfer has executed.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "bank_transfer_forbidden_ach_class"
    }}><strong parentName="h4">{`BANK_TRANSFER_FORBIDDEN_ACH_CLASS`}</strong></h4>
    <ErrorReference type='BANK_TRANSFER_ERROR' error='BANK_TRANSFER_FORBIDDEN_ACH_CLASS' subtitle="An attempt was made to create a transfer with a forbidden ACH class (SEC code)." server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-6"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">
          <p parentName="li">{`Your Plaid account has not been enabled for the ACH class specified in the request.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`The ACH class specified in the transfer request was incorrect.`}</p>
        </li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-6"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Verify that the ACH class in the request is correct.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`If you have not already done so, contact your Plaid account manager to request that the desired ACH class be enabled for your account.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "ach-return-codes"
    }}>{`ACH return codes`}</h4>
    <Callout icon={<Video mdxType="Video" />} mdxType="Callout">
      <p>{`Prefer to learn by watching? A `}<a parentName="p" {...{
          "href": "https://www.youtube.com/watch?v=7UqU2TGLiMc"
        }}>{`video guide`}</a>{` is available for this topic.`}</p>
    </Callout>
    <p>{`All `}<inlineCode parentName="p">{`reversed`}</inlineCode>{` ACH transactions will have an ACH return code. By reading the code, you can troubleshoot and debug reversed transactions.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Return Code`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Notes`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R01`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Insufficient funds`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Available balance is not sufficient to cover the dollar amount of the debit entry`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R02`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Account closed`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A previously open account is now closed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R03`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No account or unable to locate account`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The account number does not correspond to the individual identified in the entry or a valid account`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R04`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Invalid account number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The account number fails the check digit validation or may contain an incorrect number of digits`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R05`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Unauthorized debit to consumer account`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A business debit entry was transmitted to a member's consumer account, and the member had not authorized the entry`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R06`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned per ODFI's request`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The ODFI has requested that the RDFI return the entry`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R07`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Authorization revoked by customer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Member who previously authorized an entry has revoked authorization with the originator`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R08`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Payment stopped or stop payment on item`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Member had previously requested a stop payment of a single or recurring entry`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R09`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Uncollected funds`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Available balance is sufficient, but the collected balance is not sufficient to cover the entry`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R10`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Customer advises not authorized`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Member advises not authorized, notice not provided, improper source document, or amount of entry not accurately obtained from source document`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R11`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Customer advises entry not in accordance with the terms of the authorization`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A valid authorization exists, but the debit did not conform to its terms (for example, an incorrect amount, an incorrect date, or an incomplete or improperly reinitiated transaction).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R12`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Branch sold to another DFI`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`RDFI unable to post entry destined for a bank account maintained at a branch sold to another financial institution`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R13`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Invalid ACH routing number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Financial institution does not receive commercial ACH entries`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R14`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Representative payee deceased or unable to continue in that capacity`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Representative payee is deceased or unable to continue in that capacity, beneficiary is not deceased`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R15`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Beneficiary of account holder deceased`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Beneficiary or Account Holder Deceased`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Account frozen`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Access to account is restricted due to a specific action taken by the RDFI or by legal action`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R17`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`File record edit criteria`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fields rejected by RDFI processing (identified in return addenda)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R18`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Improper effective entry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Entries have been presented prior to the first available processing window for the effective date`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R19`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Amount field error`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Improper formatting of the amount field`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R20`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Non-transaction account`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Policies or regulations (such as Regulation D) prohibit or limit activity to the account indicated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R21`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Invalid company identification`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The company ID information not valid (normally CIE entries)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R22`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Invalid individual ID number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Individual id used by receiver is incorrect (CIE entries)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R23`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Credit entry refused by receiver`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Receiver returned entry because minimum or exact amount not remitted, bank account is subject to litigation, or payment represents an overpayment, originator is not known to receiver or receiver has not authorized this credit entry to this bank account`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R24`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Duplicate entry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`RDFI has received a duplicate entry`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R25`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Addenda error`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Improper formatting of the addenda record information`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R26`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Mandatory field error`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Improper information in one of the mandatory fields`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R27`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Trace number error`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Original entry trace number is not valid for return entry; or addenda trace numbers do not correspond with entry detail record`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R28`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Routing number or check digit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Check digit for transit routing number is incorrect`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R29`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Corporate customer advises not authorized`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`RDFI has been notified by business account holder that a specific transaction is unauthorized`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R30`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`RDFI not participant in check truncation program`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Financial institution not participating in automated check safekeeping application`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R31`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Permissible return entry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`RDFI may return a CCD or CTX entry that the ODFI has agreed to accept, even beyond the normal return deadline.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R32`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`RDFI non settlement`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`RDFI is not able to settle the entry`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R33`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Return of XCK entry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`RDFI determines at its sole discretion to return an XCK entry; an XCK return entry may be initiated by midnight of the sixtieth day following the settlement date if the XCK entry`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R34`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Limited participation DFI`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`RDFI participation has been limited by a federal or state supervisor`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R35`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Return of improper debit entry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ACH debit not permitted for use with the CIE standard entry class code (except for reversals)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R36`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Return of improper credit entry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R37`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Source Document Presented for Payment`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Check used for an ARC, BOC or POP entry has also been presented for payment`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R38`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Stop payment on source document`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Stop payment has been placed on a check used for an ARC entry`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R40`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Return of ENR entry by federal government agency (ENR only)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R41`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Invalid transaction code (ENR only)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R42`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Routing number or check digit error (ENR only)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R43`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Invalid DFI account number (ENR only)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R44`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Invalid individual ID number (ENR only)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R45`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Invalid individual name/company name (ENR only)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R46`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Invalid representative payee indicator (ENR only)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R47`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Duplicate enrollment`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R50`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`State law affecting RCK acceptance`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R51`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Item is ineligible, notice not provided, signature not genuine`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R52`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Stop payment on item`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R61`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Misrouted return`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Return entry was sent by RDFI to an incorrect ODFI routing/transit number`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R62`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Incorrect trace number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R63`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Incorrect dollar amount`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R64`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Incorrect individual identification`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R65`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Incorrect transaction code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R66`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Incorrect company identification`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R67`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Duplicate return`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ODFI has received more than one return entry for the same original entry`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R68`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Untimely return`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Return entry did not meet the return deadline`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R69`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Multiple errors`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R70`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Permissible return entry not accepted`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R71`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Misrouted dishonored return`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R72`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Untimely dishonored return`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R73`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Timely original return`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R74`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Corrected return`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R80`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Cross-border payment coding error`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R81`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Nonparticipant in cross-border program`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R82`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Invalid foreign receiving DFI identification`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "bank_transfer_limit_exceeded",
        level: 4,
        title: "BANK_TRANSFER_LIMIT_EXCEEDED",
      },
{
        id: "bank_transfer_missing_origination_account",
        level: 4,
        title: "BANK_TRANSFER_MISSING_ORIGINATION_ACCOUNT",
      },
{
        id: "bank_transfer_invalid_origination_account",
        level: 4,
        title: "BANK_TRANSFER_INVALID_ORIGINATION_ACCOUNT",
      },
{
        id: "bank_transfer_account_blocked",
        level: 4,
        title: "BANK_TRANSFER_ACCOUNT_BLOCKED",
      },
{
        id: "bank_transfer_insufficient_funds",
        level: 4,
        title: "BANK_TRANSFER_INSUFFICIENT_FUNDS",
      },
{
        id: "bank_transfer_not_cancellable",
        level: 4,
        title: "BANK_TRANSFER_NOT_CANCELLABLE",
      },
{
        id: "bank_transfer_forbidden_ach_class",
        level: 4,
        title: "BANK_TRANSFER_FORBIDDEN_ACH_CLASS",
      },
{
        id: "ach-return-codes",
        level: 4,
        title: "ACH return codes",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
